export default __webpack_public_path__ + "static/media/2011.8d601c41.png";